import React from 'react'
import ReactSelect from 'react-select';
import selectStyles from '../../../../ui/selectStyles.js';
import { COUNTRIES } from '../../countries.js';

const options = COUNTRIES.map((country) => ({ value: country, label: country }));

// Searchable country list (IMP-086). The form keeps the country as plain text (formData.country), so the
// submitted data has the same shape as before; a value saved by the old free-text field still shows.
export default function CountrySelect(props) {
    const inputId = `field-${props.name}`;
    const selected = props.value ? { value: props.value, label: props.value } : null;

    function handleSelect(option) {
        props.onChange({ target: { name: props.name, value: option ? option.value : '', type: 'text' } });
    }

    return (
        <div className="Select">
            <label className="TextField--label" htmlFor={inputId}>{props.label}</label>
            <div className={`Select--container${props.error ? " is-error" : ""}`}>
                <ReactSelect
                    inputId={inputId}
                    options={options}
                    value={selected}
                    onChange={handleSelect}
                    styles={selectStyles}
                    placeholder="Search for your country"
                    noOptionsMessage={() => "No country matches"}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                />
            </div>
            {props.error && <p className="TextField--error">{props.errorMessage}</p>}
        </div>
    )
}
